(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cj-hero"] && !Shopify.designMode) return;
  try {
    
function initCJHero(root = document) {
  root.querySelectorAll('[data-cj-hero]').forEach(hero => {
    if (hero.dataset.ready) return;
    hero.dataset.ready = 'true';
    const video = hero.querySelector('video');
    const button = hero.querySelector('.cj-video-toggle');
    if (!video || !button) return;
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = preference.matches || Boolean(navigator.connection?.saveData);
    const sync = () => {button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;};
    const play = () => {
      if (video.dataset.src && !video.src) video.src = video.dataset.src;
      video.muted = true;
      video.play().catch(sync);
    };
    button.hidden = false;
    button.addEventListener('click', () => {userPaused = !video.paused; if (video.paused) play(); else video.pause();});
    video.addEventListener('play', () => {hero.classList.add('is-playing'); sync();});
    video.addEventListener('pause', sync);
    video.addEventListener('error', () => {hero.classList.remove('is-playing');button.hidden = true;});
    preference.addEventListener('change', () => {if (preference.matches) {userPaused = true;video.pause();}});
    new IntersectionObserver(entries => {entries.forEach(entry => {if (entry.isIntersecting && !userPaused) play(); else video.pause();});}, {threshold: 0.1}).observe(hero);
    sync();
  });
}
initCJHero();
document.addEventListener('shopify:section:load', event => initCJHero(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
function initCJContact(root = document) {
  const field = root.querySelector('#ContactForm-project');
  if (!field || field.value || field.dataset.ready) return;
  const params = new URLSearchParams(window.location.search);
  const context = params.get('produkt') || params.get('kategori');
  if (context) field.value = context.slice(0, 300);
  field.dataset.ready = 'true';
}
initCJContact();
document.addEventListener('shopify:section:load', event => initCJContact(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.getAttribute('data-sticky-type') === 'none') return;
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (!this.onScrollHandler) return;
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
